var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"blm-nocontent-contain"},[_c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.answer.sectionId),expression:"answer.sectionId"}]},[_vm._v(_vm._s(_vm.answer.componentName))]),_c('span',[_vm._v("暂时无法回答此问题")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }